import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as SuggestionsActions from './suggestions.actions';

import { Suggestion } from '@fantaz/shared/data-access/models';

export const SUGGESTIONS_FEATURE_KEY = 'suggestions';

export interface State extends EntityState<Suggestion> {
  selectedId?: string | number; // which Suggestions record has been selected
  loaded: boolean; // has the Suggestions list been loaded
  error?: string | null; // last known error (if any)
}

export interface SuggestionsPartialState {
  readonly [SUGGESTIONS_FEATURE_KEY]: State;
}

export const suggestionsAdapter: EntityAdapter<Suggestion> =
  createEntityAdapter<Suggestion>({
    selectId: (suggestion: Suggestion) => suggestion.action,
  });

export const initialState: State = suggestionsAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const suggestionsReducer = createReducer(
  initialState,
  on(SuggestionsActions.init, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(SuggestionsActions.loadSuggestionsSuccess, (state, { suggestions }) =>
    suggestionsAdapter.setAll(suggestions, { ...state, loaded: true }),
  ),
  on(SuggestionsActions.loadSuggestionsFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return suggestionsReducer(state, action);
}
